import { render, staticRenderFns } from "./ProductCode.vue?vue&type=template&id=615e0563&scoped=true&"
import script from "./ProductCode.vue?vue&type=script&lang=js&"
export * from "./ProductCode.vue?vue&type=script&lang=js&"
import style0 from "./ProductCode.vue?vue&type=style&index=0&id=615e0563&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615e0563",
  null
  
)

export default component.exports